import { render } from "./cluster-keys-action.vue?vue&type=template&id=df4ebafe"
import script from "./cluster-keys-action.vue?vue&type=script&lang=js"
export * from "./cluster-keys-action.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__